import dayjs, { Dayjs } from "dayjs";
import nl from "dayjs/locale/nl";
import calendar from "dayjs/plugin/calendar";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";
import utcPlugin from "dayjs/plugin/utc";

dayjs.locale(nl);

dayjs.extend(updateLocale);
dayjs.extend(utcPlugin);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(calendar);

dayjs.updateLocale("nl", {
	calendar: {
		lastDay: "[Gisteren om] LT",
		sameDay: "[Vandaag om] LT",
		nextDay: "[Morgen om] LT",
		lastWeek: "[Afgelopen] dddd [om] LT",
		nextWeek: "dddd [om] LT",
		sameElse: "L",
	},
});

const utcDayJs = dayjs.utc;
function utcToLocal(dateTime: Dayjs): Dayjs {
	return dayjs.utc(dateTime).local();
}

export { dayjs as date, utcDayJs as utcDate, utcToLocal };
export default dayjs;
